import { useState, useEffect } from "react";
import { useRouteError } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import "../../index.css";
import "./ErrorPage.css";
import config from "environment";
import { selectUser } from "../../redux/features/appData";

const IMG_LOGO: string = "/logos/effno_logo.jpg";
const IMG_FOUR_O_FOUR: string = "/media/404.png";

export default function ErrorPage() {
  const navigate = useNavigate();
  const userId = useSelector(selectUser)?.id;

  const [isReadOnly, setIsReadOnly] = useState<boolean>(false);

  const error = useRouteError() as any;
  console.error(error);

  useEffect(() => {
    if (userId) {
      // setIsReadOnly(false);
    }
  }, []);

  const handleHome = () => {
    if (isReadOnly) {
      window.location.href = "https://effno.co";
      return;
    }

    navigate("/");
  };

  return (
    <div id="error-page" className={config.theme}>
      <div className="error-page-header">
        <a href="https://effno.co">
          <div className="error-page-logo">
            <img src={IMG_LOGO} style={{ width: "40px", height: "40px" }} />
            <span className="error-page-company-name">effno</span>
          </div>
        </a>

        <div className="error-page-signup">
          {isReadOnly && (
            <>
              <button
                onClick={() => {
                  navigate("/login");
                }}
                style={{ backgroundColor: "var(--button-color-secondary)" }}>
                Sign In
              </button>
              <button
                onClick={() => {
                  navigate("/signup");
                }}>
                Sign Up for Free
              </button>
            </>
          )}
        </div>
      </div>

      <div className="error-page-body">
        <img src={IMG_FOUR_O_FOUR} className="error-page-body-404" />
        <div className="error-page-text">
          The page you are looking for does not exist.
        </div>
        <button className="button-save" onClick={handleHome}>Go Home</button>
      </div>

      <div className="error-page-error">
        {error.statusText || error.message}
      </div>
    </div>
  );
}
